import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ConList from '../instituteContent';

class InsListPaginate extends React.PureComponent {
    state = {
        current: 1,
        pageSize: 10,
        total: 0,
    };
    componentDidMount = () => {
        this.initialData();
    };
    initialData = () => {
        const { content } = this.props;

        this.setState({
            total: content.length,
        });
    };
    handlePrev = e => {
        e.preventDefault();
        window.scrollTo(0, 0);
        this.setState({
            current: this.state.current - 1,
        });
    };
    handleNext = e => {
        e.preventDefault();
        window.scrollTo(0, 0);
        this.setState({
            current: this.state.current + 1,
        });
    };
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const { current, pageSize, total } = this.state;

        const shows = current * pageSize;

        const totalPage = Math.ceil(total / pageSize);

        const paginateDate = content.slice(shows - 10, shows);

        return (
            <div className={styles.content}>
                <ConList content={paginateDate} />
                <div className={styles.paging}>
                    <a
                        href="#"
                        className={styles.prev}
                        style={{ display: current === 1 ? 'none' : 'inline-block' }}
                        onClick={this.handlePrev}>
                        上一页
                    </a>
                    <a
                        href="#"
                        className={styles.next}
                        style={{ display: current === totalPage ? 'none' : 'inline-block' }}
                        onClick={this.handleNext}>
                        下一页
                    </a>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
InsListPaginate.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
InsListPaginate.defaultProps = {};

export default InsListPaginate;
